"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Agent_1 = __importDefault(require("./Agent"));
const AgentEnvironment_1 = __importDefault(require("./AgentEnvironment"));
const Messaging_1 = __importDefault(require("./Messaging"));
const Presence_1 = __importDefault(require("./Presence"));
const Storage_1 = __importDefault(require("./Storage"));
const Log_1 = __importDefault(require("../Log"));
const AgentCredentials_1 = require("./AgentCredentials");
const Contributions_1 = require("./Contributions");
const AgentConnectionStatus_1 = require("./AgentConnectionStatus");
const IotStatus_1 = require("./IotStatus");
const AppSyncStatus_1 = require("./AppSyncStatus");
const apollo_link_1 = require("apollo-link");
const apollo_client_1 = __importDefault(require("apollo-client"));
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_link_http_1 = require("apollo-link-http");
const aws_appsync_auth_link_1 = require("aws-appsync-auth-link");
const aws_appsync_subscription_link_1 = require("aws-appsync-subscription-link");
const apollo_link_error_1 = require("apollo-link-error");
class LocalAgent extends Agent_1.default {
    constructor(agentId) {
        super(agentId);
        this._iotStatus = IotStatus_1.IotStatus.INITIALIZING;
        this._appSyncStatus = AppSyncStatus_1.AppSyncStatus.INITIALIZING;
    }
    get serviceCredentials() {
        return this._serviceCredentials;
    }
    set serviceCredentials(value) {
        this._serviceCredentials = value;
    }
    get iceServers() {
        return this._serviceCredentials.iceServers;
    }
    initialize(agentToken) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.debug(`Initializing LocalAgent ${this.id}...`);
            const credentials = new AgentCredentials_1.AgentCredentials(agentToken);
            yield credentials.initialize();
            const agentId = agentToken.agentId;
            const environmentId = credentials.environmentId;
            const httpLink = apollo_link_http_1.createHttpLink({ uri: credentials.graphQLEndpoint });
            const auth = {
                type: aws_appsync_auth_link_1.AUTH_TYPE.AWS_IAM,
                credentials: credentials
            };
            const errorLink = apollo_link_error_1.onError(({ graphQLErrors, networkError }) => {
                if (graphQLErrors) {
                    graphQLErrors.forEach(({ message, locations, path }) => Log_1.default.error('AppSync error', message, locations, path));
                }
                if (networkError) {
                    Log_1.default.error('AppSync network error', networkError);
                }
                this.handleAppSyncStatusChange(AppSyncStatus_1.AppSyncStatus.ERROR);
            });
            const link = apollo_link_1.ApolloLink.from([
                errorLink,
                aws_appsync_auth_link_1.createAuthLink({ url: credentials.graphQLEndpoint, region: credentials.region, auth: auth }),
                aws_appsync_subscription_link_1.createSubscriptionHandshakeLink({ url: credentials.graphQLEndpoint, region: credentials.region, auth: auth }, httpLink)
            ]);
            const appSyncClient = new apollo_client_1.default({
                link,
                cache: new apollo_cache_inmemory_1.InMemoryCache()
            });
            if (appSyncClient) {
                this.handleAppSyncStatusChange(AppSyncStatus_1.AppSyncStatus.CONNECTED);
            }
            const presence = new Presence_1.default(appSyncClient, environmentId);
            const storage = new Storage_1.default(appSyncClient, environmentId);
            const contributions = new Contributions_1.Contributions(appSyncClient, environmentId);
            const messaging = new Messaging_1.default(agentId, environmentId, credentials);
            this.serviceCredentials = credentials;
            this._messaging = messaging;
            this._messaging.onConnection((status) => {
                this.handleIotStatusChange(status);
            });
            this._agentEnvironment = new AgentEnvironment_1.default(environmentId, presence, storage, contributions);
        });
    }
    static create(agentToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!agentToken.isValid()) {
                Log_1.default.error('Invalid agent token provided');
                return;
            }
            const localAgent = new LocalAgent(agentToken.agentId);
            yield localAgent.initialize(agentToken);
            return localAgent;
        });
    }
    handleAppSyncStatusChange(status) {
        this._appSyncStatus = status;
        this.notifyConnectionStatusChange();
    }
    handleIotStatusChange(status) {
        this._iotStatus = status;
        this.notifyConnectionStatusChange();
    }
    notifyConnectionStatusChange() {
        var _a, _b, _c, _d;
        if (this._appSyncStatus === AppSyncStatus_1.AppSyncStatus.ERROR) {
            (_a = this._connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this, AgentConnectionStatus_1.AgentConnectionStatus.ERROR);
        }
        else if (this._iotStatus !== IotStatus_1.IotStatus.INITIALIZING && this._iotStatus !== IotStatus_1.IotStatus.CONNECTED) {
            (_b = this._connectionHandler) === null || _b === void 0 ? void 0 : _b.call(this, AgentConnectionStatus_1.AgentConnectionStatus.OFFLINE);
        }
        else if (this._iotStatus === IotStatus_1.IotStatus.CONNECTED && this._appSyncStatus === AppSyncStatus_1.AppSyncStatus.CONNECTED) {
            (_c = this._connectionHandler) === null || _c === void 0 ? void 0 : _c.call(this, AgentConnectionStatus_1.AgentConnectionStatus.CONNECTED);
        }
        else if (this._iotStatus === IotStatus_1.IotStatus.INITIALIZING || this._appSyncStatus === AppSyncStatus_1.AppSyncStatus.INITIALIZING) {
            (_d = this._connectionHandler) === null || _d === void 0 ? void 0 : _d.call(this, AgentConnectionStatus_1.AgentConnectionStatus.INITIALIZING);
        }
        else {
            Log_1.default.warn(`Unexpected AgentConnectionStatus state. iotStatus: ${this._iotStatus} appSyncStatus: ${this._appSyncStatus}`);
        }
    }
    onConnection(connectionHandler) {
        this._connectionHandler = connectionHandler;
    }
    connect() {
        Log_1.default.debug(`Connecting to AgentEnvironment ${this._agentEnvironment.id}...`);
        this._messaging.connect();
    }
    disconnect() {
        Log_1.default.debug(`Disconnecting from AgentEnvironment ${this._agentEnvironment.id}...`);
        this._messaging.disconnect();
        this._agentEnvironment.unsubscribeFromPresence();
    }
    sendMessage(type, message, remoteAgent) {
        this._messaging.sendMessage(type, message, remoteAgent);
    }
    subscribeToMessages(type, handlers) {
        this._messaging.subscribeToMessages(type, handlers);
    }
    unsubscribeFromMessages(handler, type) {
        this._messaging.unsubscribeFromMessages(handler, type);
    }
    subscribeToPresence(type, handlers) {
        this._agentEnvironment.subscribeToPresence(type, handlers);
    }
    unsubscribeFromPresence(type) {
        this._agentEnvironment.unsubscribeFromPresence(type);
    }
    getRemoteAgents() {
        return this._agentEnvironment.getRemoteAgents();
    }
    writeToStorage(key, value, agent) {
        return this._agentEnvironment.writeToStorage(key, value, agent);
    }
    getFromStorage(key, agent) {
        return this._agentEnvironment.getFromStorage(key, agent);
    }
    getKeysFromStorage(agent) {
        return this._agentEnvironment.getKeysFromStorage(agent);
    }
    removeFromStorage(key, agent) {
        return this._agentEnvironment.removeFromStorage(key, agent);
    }
    removeAllFromStorage(agent) {
        return this._agentEnvironment.removeAllFromStorage(agent);
    }
    subscribeToStorage(key, agent, handler) {
        return this._agentEnvironment.subscribeToStorage(key, agent, handler);
    }
    unsubscribeFromStorage(key, agent) {
        this._agentEnvironment.unsubscribeFromStorage(key, agent);
    }
    get agentEnvironment() {
        return this._agentEnvironment;
    }
    unsubscribeFromContributions(type, agent) {
        this._agentEnvironment.unsubscribeFromContributions(type, agent);
    }
    makeContribution(contribution, agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._agentEnvironment.makeContribution(contribution, agentId ? agentId : this.id);
        });
    }
    getContributions(type, agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._agentEnvironment.getContributions(type, agentId);
        });
    }
    getTypesFromContributions(agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._agentEnvironment.getTypesFromContributions(agentId);
        });
    }
    removeContribution(contribution) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._agentEnvironment.removeContribution(contribution);
        });
    }
    removeAllFromContributions(agent) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._agentEnvironment.removeAllFromContributions(agent);
        });
    }
    subscribeToContributions(type, handler, agentId) {
        this._agentEnvironment.subscribeToContributions(type, handler, agentId);
    }
}
exports.default = LocalAgent;
//# sourceMappingURL=LocalAgent.js.map